import * as yup from 'yup';

const zipRegex = /^[0-9]{5}([- /]?[0-9]{4})?$/;
const stateRegex =
  /^(?:Ala(?:(?:bam|sk)a)|American Samoa|Arizona|Arkansas|(?:^(?!Baja )California)|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Guam|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Miss(?:(?:issipp|our)i)|Montana|Nebraska|Nevada|New (?:Hampshire|Jersey|Mexico|York)|North (?:(?:Carolin|Dakot)a)|Ohio|Oklahoma|Oregon|Pennsylvania|Puerto Rico|Rhode Island|South (?:(?:Carolin|Dakot)a)|Tennessee|Texas|Utah|Vermont|Virgin(?:ia| Island(s?))|Washington|West Virginia|Wisconsin|Wyoming|A[KLRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$/;
const clientFormSchema = yup.object().shape({
  name: yup.string().required('Required'),
  billingAddressLine1: yup.string().required('Required'),
  billingAddressLine2: yup.string(),
  billingAddressZip: yup
    .string()
    .matches(zipRegex, 'Enter a valid ZIP Code (e.g. 90011 or 90012-4801)')
    .required('Required'),
  billingAddressState: yup
    .string()
    .matches(stateRegex, 'Enter a valid state (e.g. CA or California)')
    .required('Required'),
  billingAddressCity: yup.string().required('Required'),
  connection: yup.string().required('Required'),
});

export default clientFormSchema;
